import { AvField, AvForm } from 'availity-reactstrap-validation'
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Button, Col, FormGroup, Label, Row } from 'reactstrap'
import Select from 'react-select'
import PageTitle from '../../../../Layout/AppMain/pageTitle'
import { request } from '../../../../Redux/Sagas/requests/api'
import { clearCurrentRowData, clearParentTableData, fetchUpdateApiData } from '../../../../Redux/Reducers/CMS'
import { isSuccessResponse } from '../../../../helper'
import TicketFileUpload from '../EditTicket/ticketChat/ticketFileUpload'

const AddTicket = ({ setAddGridDataDetail }) => {
  const dispatch = useDispatch()
  const [submitting, setSubmitting] = useState(false)
  const [base64File, setBase64File] = useState()
  const [file, setFile] = useState()
  const [queryTypeOptions, setQueryTypeOptions] = useState([])
  const [userGroupOptions, setUserGroupOptions] = useState([])
  const [selectedQueryType, setSelectedQueryType] = useState(null)
  const [selectedUserGroups, setSelectedUserGroups] = useState([])
  const [optionsError, setOptionsError] = useState('')

  useEffect(() => {
    request('raise-ticket/ticket/admin-create-options', 'GET')
      .then((res) => {
        if (res?.status === 200 || res?.status === 201) {
          const queryTypes = (res?.data?.data?.query_types || []).map((row) => ({
            value: row.id,
            label: row.name,
          }))
          const userGroups = (res?.data?.data?.user_groups || []).map((row) => ({
            value: row.id,
            label: row.name,
          }))
          setQueryTypeOptions(queryTypes)
          setUserGroupOptions(userGroups)
          setOptionsError('')
        } else {
          setOptionsError(res?.data?.message || 'Could not load query types / groups.')
        }
      })
      .catch(() => setOptionsError('Could not load query types / groups.'))
  }, [])

  const onGoBack = () => {
    dispatch(fetchUpdateApiData())
    dispatch(clearCurrentRowData())
    dispatch(clearParentTableData())
    setAddGridDataDetail({ open: false })
  }

  const onSubmit = (_e, values) => {
    if (!selectedQueryType?.value || !selectedUserGroups?.length) {
      return
    }
    setSubmitting(true)
    request('raise-ticket/ticket/admin-create', 'POST', {
      subject: values.subject,
      message: values.message,
      booking_id: values.booking_id || null,
      query_type_id: selectedQueryType.value,
      user_groups: selectedUserGroups.map((row) => ({ value: row.value, label: row.label })),
      attachment: base64File || null,
    })
      .then((res) => {
        if (isSuccessResponse(res, 'Ticket created successfully!')) {
          onGoBack()
        }
      })
      .finally(() => setSubmitting(false))
  }

  return (
    <div className='px-3'>
      <PageTitle heading='Add Ticket' subheading='Raise a new query ticket' icon='pe-7s-browser icon-gradient bg-happy-fisher' hideBreadCrumbs />
      <Button color='dark' className='mt-2 mb-3' onClick={onGoBack}>
        Back
      </Button>
      {optionsError ? <div className='text-danger mb-3'>{optionsError}</div> : null}
      <AvForm onValidSubmit={onSubmit} className='mt-3'>
        <Row>
          <Col md='6'>
            <AvField name='subject' label='Subject' type='text' required />
            <FormGroup>
              <Label>
                Query Type <span className='text-danger'>*</span>
              </Label>
              <Select
                options={queryTypeOptions}
                value={selectedQueryType}
                onChange={setSelectedQueryType}
                placeholder='Select query type…'
                isClearable
              />
              {!selectedQueryType ? <small className='text-danger'>Query type is required.</small> : null}
            </FormGroup>
            <FormGroup>
              <Label>
                Assigned to <span className='text-danger'>*</span>
              </Label>
              <Select
                options={userGroupOptions}
                value={selectedUserGroups}
                onChange={(value) => setSelectedUserGroups(value || [])}
                placeholder='Select user group(s)…'
                isMulti
                isClearable
              />
              {!selectedUserGroups?.length ? <small className='text-danger'>Assigned to is required.</small> : null}
            </FormGroup>
            <AvField
              name='booking_id'
              label='Booking ID (optional)'
              type='text'
              helpMessage='Optional — links the ticket to a booking when provided.'
            />
          </Col>
          <Col md='6'>
            <AvField name='message' label='Message' type='textarea' rows='10' required />
            <FormGroup>
              <Label>Attachment (optional)</Label>
              <TicketFileUpload setBase64File={setBase64File} setFile={setFile} file={file} />
              <small className='text-muted d-block mt-1'>Optional — PDF, CSV, images, Office docs, zip, etc. (max 10MB).</small>
            </FormGroup>
          </Col>
        </Row>
        <Button
          color='success'
          disabled={submitting || !selectedQueryType || !selectedUserGroups?.length}
          className='mt-2'>
          {submitting ? 'Creating…' : 'Create Ticket'}
        </Button>
      </AvForm>
    </div>
  )
}

export default AddTicket
